<div class="unit-input-container d-flex gap-2">
  <!-- Numeric Input -->
  <input
    type="number"
    class="form-control"
    [value]="numericValue || ''"
    [placeholder]="placeholder"
    [min]="min"
    [max]="max"
    [step]="step"
    [disabled]="disabled"
    (input)="onValueChange($event)"
    (blur)="onBlur()"
  >

  <!-- Unit Dropdown -->
  <select
    class="form-select"
    [value]="selectedUnit"
    [disabled]="disabled"
    (change)="onUnitChange($event)"
    (blur)="onBlur()"
  >
    <option *ngFor="let unit of units" [value]="unit.value">
      {{ unit.shortLabel || unit.label }}
    </option>
  </select>
</div>
